import { mixed, object, string } from 'yup';
import { CreditCardType } from '../../../../payment/domain/models';
import { IPaymentDetails, TokenType } from './IPaymentDetails';

export const paymentDetailsSchema = object<IPaymentDetails>({
	token: string().required(),
	creditCardType: mixed<CreditCardType>()
		.transform((value: unknown) =>
			typeof value === 'string' ? value.toUpperCase() : value,
		)
		.oneOf(Object.values(CreditCardType))
		.required(),
	maskedCreditCardNumber: string().required(),
	tokenType: mixed<TokenType>().oneOf(['transient', 'reusable']).optional(),
}).required();
